<template>
   <div class="sidebar-container" :class="{'msg-expanded': !msgCollapsed}">
      <div class="sidebar-content">
         <b-navbar-brand class="brand" :to="{name: 'Home'}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1275.59 368.5" class="logo">
               <g id="a" />
               <g id="b" />
               <g id="c">
                  <g>
                     <path
                        class="f"
                        d="M123.91,182.02h-24.5c0,50.01,40.54,90.55,90.55,90.55v-24.5c-36.48,0-66.05-29.57-66.05-66.05Z"
                     />
                     <path
                        class="e logo-long"
                        d="M663.42,134.37h24.6v95.31h-24.6v-11.25c-7.37,9.28-17.72,13.92-31.07,13.92s-23.6-4.86-32.69-14.58c-9.09-9.71-13.62-21.63-13.62-35.74s4.53-26.02,13.62-35.74c9.09-9.71,19.98-14.58,32.69-14.58,13.36,0,23.7,4.64,31.07,13.92v-11.25Zm-45.36,67c4.95,5.03,11.25,7.54,18.86,7.54s13.95-2.51,18.97-7.54c5.03-5.01,7.52-11.46,7.52-19.35s-2.5-14.32-7.52-19.35c-5.03-5.03-11.34-7.52-18.97-7.52s-13.92,2.5-18.86,7.52c-4.96,5.03-7.43,11.46-7.43,19.35s2.47,14.33,7.43,19.35Z"
                     />
                     <path
                        class="e logo-long"
                        d="M732.66,150.76c2.3-6.1,6.07-10.67,11.34-13.73,5.27-3.04,11.15-4.58,17.64-4.58v27.46c-7.51-.88-14.21,.64-20.11,4.58-5.91,3.94-8.87,10.49-8.87,19.62v45.56h-24.59v-95.31h24.59v16.4Z"
                     />
                     <path
                        class="e logo-long"
                        d="M842.3,96.25h24.59V229.68h-24.59v-11.25c-7.24,9.28-17.53,13.92-30.89,13.92s-23.8-4.86-32.87-14.58c-9.09-9.71-13.64-21.63-13.64-35.74s4.55-26.02,13.64-35.74c9.08-9.71,20.04-14.58,32.87-14.58s23.64,4.64,30.89,13.92v-49.36Zm-45.27,105.12c5.01,5.03,11.34,7.54,18.96,7.54s13.92-2.51,18.88-7.54c4.95-5.01,7.43-11.46,7.43-19.35s-2.48-14.32-7.43-19.35c-4.96-5.03-11.25-7.52-18.88-7.52s-13.95,2.5-18.96,7.52c-5.03,5.03-7.54,11.46-7.54,19.35s2.51,14.33,7.54,19.35Z"
                     />
                     <path
                        class="e logo-long"
                        d="M905.26,228.55c-2.03,2.02-4.51,3.04-7.43,3.04s-5.4-1.02-7.43-3.04c-2.03-2.03-3.06-4.51-3.06-7.45s1.02-5.4,3.06-7.43c2.03-2.03,4.51-3.06,7.43-3.06s5.4,1.02,7.43,3.06c2.03,2.03,3.06,4.51,3.06,7.43s-1.02,5.41-3.06,7.45Z"
                     />
                     <path
                        class="e logo-long"
                        d="M1060.38,134.37h12.58v95.31h-12.58v-18.68c-8.77,13.98-21.61,20.97-38.5,20.97-13.61,0-25.19-4.84-34.8-14.49-9.59-9.66-14.38-21.49-14.38-35.46s4.79-25.8,14.38-35.45c9.6-9.66,21.19-14.49,34.8-14.49,16.89,0,29.74,6.98,38.5,20.96v-18.68Zm-64.24,74.45c7.24,7.31,16.13,10.95,26.68,10.95s19.45-3.65,26.7-10.95c7.24-7.31,10.86-16.24,10.86-26.79s-3.61-19.47-10.86-26.78c-7.24-7.31-16.15-10.97-26.7-10.97s-19.44,3.66-26.68,10.97c-7.24,7.31-10.86,16.23-10.86,26.78s3.61,19.48,10.86,26.79Z"
                     />
                     <path
                        class="e logo-long"
                        d="M1177.46,229.68h-15.06l-29.72-39.33-29.74,39.33h-15.06l37.26-49.29-34.78-46.03h15.05l27.27,36.07,27.26-36.07h15.05l-34.78,46.03,37.26,49.29Z"
                     />
                     <path
                        class="e logo-long"
                        d="M308.38,131.7c10.43,0,19.04,3.51,25.83,10.49,6.79,7,10.19,16.65,10.19,28.98v58.52h-24.59v-55.48c0-6.35-1.71-11.2-5.13-14.58-3.44-3.37-8.02-5.04-13.73-5.04-6.36,0-11.43,1.97-15.25,5.91-3.82,3.94-5.72,9.85-5.72,17.72v51.47h-24.59v-95.31h24.59v10.67c5.97-8.89,15.44-13.34,28.41-13.34Z"
                     />
                     <path
                        class="e logo-long"
                        d="M418.6,131.7c12.83,0,23.8,4.87,32.87,14.58,9.09,9.73,13.64,21.64,13.64,35.74s-4.55,26.03-13.64,35.74c-9.08,9.73-20.04,14.58-32.87,14.58s-23.64-4.64-30.89-13.92v11.25h-24.59V96.25h24.59v49.36c7.24-9.28,17.55-13.92,30.89-13.92Zm-23.46,69.67c4.96,5.03,11.25,7.54,18.88,7.54s13.95-2.51,18.97-7.54c5.01-5.01,7.52-11.46,7.52-19.35s-2.51-14.32-7.52-19.35c-5.03-5.03-11.36-7.52-18.97-7.52s-13.92,2.5-18.88,7.52c-4.95,5.03-7.43,11.46-7.43,19.35s2.48,14.33,7.43,19.35Z"
                     />
                     <path
                        class="e logo-long"
                        d="M551.4,182.02c0,14.26-11.56,25.83-25.83,25.83s-25.83-11.56-25.83-25.83,11.56-25.83,25.83-25.83,25.83,11.56,25.83,25.83Zm-25.83-50.32c-27.79,0-50.32,22.53-50.32,50.32s22.53,50.32,50.32,50.32,50.32-22.53,50.32-50.32-22.53-50.32-50.32-50.32Z"
                     />
                     <path
                        class="e logo-long"
                        d="M965.41,146.58v-12.21h-27.44v-26.68h-12.58v96.65c0,11.06,3.34,18.55,10.01,22.49,6.67,3.94,16.68,4.89,30.02,2.85v-11.05c-6.1,.25-11.17,.34-15.25,.28-4.06-.06-7.11-1.21-9.14-3.43-2.05-2.22-3.06-5.94-3.06-11.15v-57.76h27.44Z"
                     />
                     <path
                        class="e"
                        d="M215.79,182.02c0,14.26-11.56,25.83-25.83,25.83s-25.83-11.56-25.83-25.83,11.56-25.83,25.83-25.83,25.83,11.56,25.83,25.83Zm-25.83-50.32c-27.79,0-50.32,22.53-50.32,50.32s22.53,50.32,50.32,50.32,50.32-22.53,50.32-50.32-22.53-50.32-50.32-50.32Z"
                     />
                     <text
                        class="e"
                        x="1170"
                        y="135"
                        font-family="Arial, Helvetica, sans-serif"
                        font-size="55"
                        font-weight="bold"
                     >
                        ®
                     </text>
                  </g>
               </g>
               <g id="d" />
            </svg>
         </b-navbar-brand>

         <div class="stages-container">
            <div class="stage-list">
               <div
                  v-for="(stage, index) in listStages"
                  :key="index"
                  :id="`sidebar-item-${index + 1}`"
                  class="stage-item"
               >
                  <router-link
                     class="stage"
                     :class="{active: stage.active}"
                     :to="{name: stage.route}"
                  >
                     <custom-icon
                        :icon="stage.icon"
                        class="stage-icon"
                        width="0.84375rem"
                        height="0.875rem"
                     />
                     <span class="ml-2 stage-name">
                        {{ stage.name }}
                     </span>
                     <div v-if="stage.name === 'Flags' && activeFlags > 0" class="stage-flag-count">
                        {{ activeFlags }}
                     </div>
                  </router-link>
               </div>
            </div>

            <div class="progress-container">
               <b-dropdown
                  v-if="openStudies.length > 1"
                  id="select-sb-study"
                  size="sm"
                  class="period-select mb-2"
                  :text="activeStudyLabel"
                  v-b-tooltip="{
                     title: activeStudyLabel,
                     delay: {show: 300, hide: 0},
                     trigger: 'hover',
                  }"
               >
                  <b-dropdown-item
                     v-for="option in studyOptions"
                     :key="`open-study-${option.value}`"
                     class="period-item"
                     @click="selectStudy(option.value)"
                  >
                     <span>{{ option.text }}</span>
                  </b-dropdown-item>
               </b-dropdown>

               <div
                  v-if="isAppConfigured"
                  class="d-flex flex-column align-items-center progress-container__status"
               >
                  <b-progress
                     :value="progressTotal"
                     :max="100"
                     variant="white"
                     class="w-100 progress-white"
                  ></b-progress>
                  <div class="d-flex align-items-center w-100 justify-content-between">
                     <span class="progress-bar-text">Completed</span>
                     <span id="progress-percentage-sidebar" class="progress-bar-text bold"
                        >{{ progressTotal }}%</span
                     >
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="background"></div>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   data() {
      return {
         userFlags: [],
      };
   },

   computed: {
      ...mapGetters({
         stages: 'stages',
         progress: 'progress/activeStudyProgress',
         isAppConfigured: 'isAppConfigured',
         msgCollapsed: 'messaging/clientMessagingCollapsed',
         openStudies: 'companies/openStudies',
         activeStudyId: 'companies/activeStudyId',
         activeStudy: 'companies/activeStudy',
         profile: 'profile',
         shouldFetchFlags: 'flags/shouldFetchFlags',
         isSME: 'isSME',
         isCustomer: 'isCustomer',
         questionnaires: 'questionnaire/questionnaires',
         importedVendorsSupplies: 'supplies/importedVendors',
         manualVendorsSupplies: 'supplies/manualVendors',
         importedVendorsCloud: 'cloud/importedVendors',
         manualVendorsCloud: 'cloud/manualVendors',
         importedVendorsContractors: 'contractors/importedVendors',
         manualVendorsContractors: 'contractors/manualVendors',
      }),
      listStages() {
         const hiddenStages = [];
         if (this.isSME) {
            if (this.assignments.length === 0) hiddenStages.push('Supplies');
            if (this.cloudAssignments.length === 0) hiddenStages.push('Cloud Computing');
            if (this.contractorAssignments.length === 0) hiddenStages.push('Contract Research');
         }
         if (this.questionnaires.length === 0) hiddenStages.push('Questionnaires');

         return this.stages.filter((stage) => !hiddenStages.includes(stage.name));
      },

      /** The current total progress percentage */
      progressTotal() {
         return this.progress.total;
      },

      activeStudyLabel() {
         return this.openStudies.find((study) => study.id == this.activeStudyId).label;
      },

      studyOptions() {
         return this.openStudies.map((study) => ({value: study.id, text: study.label}));
      },

      assignedFlags() {
         return this.isCustomer
            ? this.userFlags
            : this.userFlags.filter((flag) => flag.userId == this.profile.id);
      },

      assignedFixFlags() {
         return this.assignedFlags.filter(
            (flag) => flag.severityLevel === this.$constants().FlagStates.MUST_FIX
         );
      },

      assignedVerifyFlags() {
         return this.assignedFlags.filter(
            (flag) =>
               flag.severityLevel === this.$constants().FlagStates.MUST_VERIFY && !flag.verified
         );
      },

      activeFlags() {
         return this.assignedVerifyFlags.length + this.assignedFixFlags.length;
      },

      assignments() {
         return [...this.importedVendorsSupplies, ...this.manualVendorsSupplies].filter(
            ({assigneeId}) => assigneeId === this.profile.id
         );
      },

      cloudAssignments() {
         return [...this.importedVendorsCloud, ...this.manualVendorsCloud].filter(
            ({assigneeId}) => assigneeId === this.profile.id
         );
      },
      contractorAssignments() {
         return [...this.importedVendorsContractors, ...this.manualVendorsContractors].filter(
            ({assigneeId}) => assigneeId === this.profile.id
         );
      },
   },

   methods: {
      async selectStudy(studyId) {
         const requests = [
            this.$store.dispatch('companies/loadCompany', {companyId: this.$companyId}),
            this.$store.dispatch('progress/loadProgress', {
               companyId: this.$companyId,
               allStudies: true,
            }),
         ];
         await this.blockUntilAllSettled(requests);
         this.$store.commit('companies/setActiveStudy', studyId);
         this.navigateAfterStudyChange();
      },

      navigateAfterStudyChange() {
         const targetStage = this.listStages.find((stage) => stage.id === this.$route.meta.stage);

         if (targetStage) {
            return this.pushRouteIfChanged(targetStage.route);
         }

         this.pushRouteIfChanged('Home');
      },

      pushRouteIfChanged(routeName) {
         if (this.$route.name !== routeName) {
            this.$router.push({name: routeName});
         }
      },

      async loadProjects() {
         await this.$store.dispatch('projects/loadProjects', {companyId: this.$companyId});
      },

      async loadAssignments() {
         await this.loadProjects();
         await Promise.all([
            this.$store.dispatch('cloud/loadAllAssignmentsByCompanyId', {
               companyId: this.$companyId,
            }),
            this.$store.dispatch('supplies/loadAllAssignmentsByCompanyId', {
               companyId: this.$companyId,
            }),
            this.$store.dispatch('contractors/loadAllAssignmentsByCompanyId', {
               companyId: this.$companyId,
            }),
         ]);
      },

      async loadQuestionnaires() {
         this.$store.dispatch('questionnaire/loadQuestionnaires', {companyId: this.$companyId});
      },

      async loadFlags() {
         this.userFlags = await this.$store.dispatch('flags/fetchFlags', {
            companyId: this.profile.companyId,
            studyId: this.activeStudyId,
         });
      },
   },

   watch: {
      async activeStudyId(newVal, oldVal) {
         if (newVal !== oldVal) {
            await this.loadAssignments();
            await this.loadQuestionnaires();
         }
      },
      async shouldFetchFlags(newValue, oldVal) {
         if (newValue !== oldVal) {
            await this.loadFlags();
         }
      },
   },

   async created() {
      await this.loadAssignments();
      await this.loadQuestionnaires();
      await this.loadFlags();
   },
};
</script>

<style lang="scss" scoped>
$sidebar-dark: $gray-900;
$sidebar-width: 13rem;
$sidebar-width-collapsed: 3.9rem;

@mixin collapse {
   overflow-x: visible;
   width: $sidebar-width-collapsed;

   .sidebar-content {
      pointer-events: none;
   }

   .brand {
      pointer-events: auto;
      width: 3.5rem;
      padding-left: 0.3rem;
      overflow-x: hidden;

      .logo-long {
         display: none;
      }
   }

   .background {
      width: $sidebar-width-collapsed;
   }

   .progress-container {
      display: none;
   }

   .dashboard-container {
      padding: 12px 14px 12px 9px;
      text-align: left;
   }

   .stage-name {
      display: inline-block;
      width: 0;
      overflow: hidden;
      flex-shrink: 0;
      white-space: nowrap;
      transition: width 0.3s ease;
   }

   .stage {
      padding: 16px 14px 16px 18px;
   }

   .stage-item {
      pointer-events: auto;
      width: $sidebar-width-collapsed;
      background: $secondary;
      transition: width 0.3s ease;
      font-size: 0.8125rem;
   }

   .stage-item:hover {
      width: $sidebar-width;
      box-shadow: 0px 4px 20px 0px #005d8b26;
      .stage-name {
         width: 10rem;
      }
   }
}

.stage-name {
   font-size: 0.8125rem;
}

.sidebar-container {
   width: $sidebar-width;
   position: fixed;
   left: 0;
   top: 0;
   bottom: 0;
   z-index: 1030;

   .background {
      width: $sidebar-width;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 1029;
      background: $secondary;
      box-shadow: 0px 4px 20px 0px #005d8b26;
   }

   .sidebar-content {
      // display: block;
      width: $sidebar-width;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 1030;
      overflow-y: auto;
      // Hide the scrollbar in various browsers
      &::-webkit-scrollbar {
         display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
   }

   .progress-container {
      background-color: $secondary;
      color: $white;
      padding: 0.3rem 1rem 1rem 1rem;
      display: flex;
      flex-direction: column;
      width: 100%;
      position: sticky;
      bottom: 0;

      &__status {
         gap: 0.5rem;
      }
   }

   .progress-bar-text {
      font-size: 0.75rem;
   }

   ::v-deep .period-select {
      button {
         background: $secondary !important;
         text-align: left;
         border: none;
         box-shadow: none !important;
      }

      .dropdown-toggle {
         display: block;
         width: 100%;
         text-align: left;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
         padding-right: 20px;
         position: relative;

         &::after {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            display: inline-block;
         }
      }
   }

   .period-item {
      font-size: 0.875rem;

      span {
         white-space: normal;
      }
   }

   .brand {
      margin-top: 16px;
      margin-bottom: 2rem;
      margin-right: 0;
      padding: 0;
      display: block;
      text-align: center;

      .logo {
         width: 192px;
         .e {
            fill: $white;
         }
         .f {
            fill: $primary;
         }
      }

      img {
         width: 12rem;
      }
   }

   .dashboard-container {
      padding: 20px 14px;
      text-align: center;

      .btn {
         padding-top: 0.5rem;
         padding-bottom: 0.5rem;

         svg {
            margin-right: 0.5rem;
         }
      }
   }

   .stages-container {
      color: $white;
      height: calc(100% - 103.5px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
   }

   .stage-list {
      list-style: none;
      padding: 0;
      width: 100%;
   }

   .stage {
      padding: 18px 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.2s ease;
      background: transparent;
      color: $white;
      text-decoration: none;

      &:hover {
         color: $primary-200;
      }

      .stage-icon {
         flex-shrink: 0;
         font-size: 0.5625rem;
      }

      .stage-flag-count {
         margin-left: 0.3125rem;
         display: inline-flex;
         align-items: center;
         justify-content: center;
         flex-shrink: 0;
         width: 0.9rem;
         height: 0.9rem;
         padding: 0 0.35rem;
         border-radius: 10px;
         background: $danger;
         color: $white;
         font-size: 0.5rem;
         font-weight: 700;
         line-height: 1;
      }

      &.active {
         background-color: $primary;
      }
   }

   @media (max-width: 959px) {
      @include collapse;
   }

   &.msg-expanded {
      @media all and (max-width: 1335px) {
         @include collapse;
      }
   }
}
</style>
